import { PillVariant } from "./Pill.controller";
import styles from "./Pill.module.css";

type PillProps = {
  label: string;
  variant?: PillVariant;
};

const Pill = ({ label, variant = "default" }: PillProps) => {
  const variantClass = variant === "soft" ? styles.soft : "";

  return <span className={`${styles.pill} ${variantClass}`.trim()}>{label}</span>;
};

export default Pill;
